import { requestCommon } from 'live/lib/utils'
import _ from 'lodash'; // @ts-ignore: Unreachable code error
import { extractJson } from 'plugin-liverig/shared/asset/lib/utils'
import {
    GlobalRequest,
    PresetDataType,
    PresetListRequestType,
    PresetRequestType,
    PresetType,
    PresetTypeInfo
} from '../../ModelsConfigTypes'

const BASE_URL = '/services/plugin-rig-state/rig-state-model'

export function getPresetDataById(rigId, pressetId: string, callBack: (preset: PresetDataType) => void): void {
    !_.isUndefined(pressetId) &&
        presetRequest<PresetRequestType>(`${BASE_URL}/${rigId}/presets/${pressetId}`).then(resp => {
            getGlobalPreset(globalPreset => {
                callBack({ ...globalPreset, ...resp.parameters })
            })
        })
}

export function getListPreset(rigId: string, callBack: (presetList: PresetTypeInfo[]) => void): void {
    presetRequest<PresetListRequestType>(`${BASE_URL}/${rigId}`).then(presetResponse => {
        const listPreset = presetResponse.presets.map(preset => {
            return {
                id: preset.id,
                name: preset.name,
                updatedAt: preset.updatedAt,
                active: preset.active
            }
        })
        callBack(listPreset)
    })
}

export function savePreset(
    rigId: string,
    preset: PresetType,
    callBack: (result: { preset: PresetType; success: boolean; error?: any }) => void
): void {
    if (preset.name === STANDARD_PARAMETERS) {
        return
    }
    presetRequest<PresetRequestType>(`${BASE_URL}/${rigId}/presets`, {
        method: 'POST',
        body: JSON.stringify(preset)
    })
        .then(presetResponse =>
            callBack({
                preset: presetResponse,
                success: true
            })
        )
        .catch(error => error.json())
        .then(error => {
            callBack({
                preset: preset as PresetRequestType,
                success: false,
                error
            })
        })
}

export function updatePreset(
    rigId: string,
    preset: PresetType,
    callBack: (result: { preset: PresetType; success: boolean; error?: any }) => void
): void {
    if (preset.id === `unsaved-preset-${preset.name}`) {
        return callBack({
            preset: preset,
            success: false,
            error: {
                message: 'Preset Unsaved'
            }
        })
    }

    preset.id &&
        presetRequest<PresetRequestType>(`${BASE_URL}/${rigId}/presets/${preset.id}`, {
            method: 'PUT',
            body: JSON.stringify(preset)
        })
            .then(presetResponse =>
                callBack({
                    preset: presetResponse,
                    success: true
                })
            )
            .catch(error => {
                return error.json().then(error => {
                    callBack({
                        preset: preset,
                        success: false,
                        error
                    })
                })
            })
}

export function dismissAll(
    rigId: string,
    preset: PresetType,
    callBack: (result: { preset: PresetType; success: boolean; error?: any }) => void
): void {
    preset.id &&
        presetRequest<PresetRequestType>(`${BASE_URL}/${rigId}/timestamp/${preset.id}`, {
            method: 'PUT'
        })
            .then(presetResponse =>
                callBack({
                    preset: presetResponse,
                    success: true
                })
            )
            .catch(error => error.json())
            .then(error => {
                callBack({
                    preset: preset,
                    success: false,
                    error
                })
            })
}

export function deletePreset(
    rigId: string,
    presetId: string,
    callBack: (result: { success: boolean; presetId: string }) => void
): void {
    presetId &&
        fetch(`${BASE_URL}/${rigId}/presets/${presetId}`, {
            method: 'DELETE'
        })
            .then(resp => {
                callBack({
                    presetId,
                    success: resp.status !== 400
                })
            })
            .catch(error => {
                callBack({
                    presetId,
                    success: false
                })
            })
}

export function getGlobalPreset(callBack: (globalPreset: PresetDataType) => void) {
    presetRequest(`/services/plugin-rig-state/config/rig-state-model`).then((globalResponse: GlobalRequest) => {
        const globalPreset = Object.keys(globalResponse.constants).reduce((preset, parameter) => {
            preset[parameter] = globalResponse.parameters?.[parameter]
                ? globalResponse.parameters[parameter]
                : {
                      value: globalResponse.constants[parameter]
                  }

            return preset
        }, {} as PresetDataType)

        callBack(globalPreset)
    })
}

export function presetRequest<TResponse>(url: string, config: RequestInit = {}): Promise<TResponse> {
    return fetch(url, { ...requestCommon, ...config })
        .then(extractJson)
        .then(data => data as TResponse)
}

export const STANDARD_PARAMETERS = 'Standard model'
